import React, { useState, useEffect } from 'react';
import logo from '../images/logo.png';
import style from '../css/NavBar.module.css';
import { Link } from 'react-router-dom';
import { FaPhone, FaUser } from 'react-icons/fa';
import { FaBars, FaX } from 'react-icons/fa6';
import { FaMapMarkerAlt } from 'react-icons/fa';

function Navbar() {
	const [show, setShow] = useState(false);

	useEffect(() => {
		if (show) {
			document.body.style.overflow = 'hidden';
			window.scrollTo(0, 0);
		} else {
			document.body.style.overflow = 'auto';
		}

		return () => {
			document.body.style.overflow = 'auto';
		};
	}, [show]);

	return (
		<div>
			<div className={style.container}>
				<div className={style.btn_box}>
					<img src={logo} alt="" className={style.logo} />
					<Link className={style.btn} to={'/'}>
						Home
					</Link>
					<Link className={style.btn} to={'/service'}>
						Services
					</Link>
					<Link className={style.btn} to={'/about-us'}>
						About Us
					</Link>
					<Link className={style.btn} to={'/contact-us'}>
						Contact Us
					</Link>
					<Link
						className={style.btn}
						to={'https://customer.hometech-repairs.in/'}
					>
						Login <FaUser size={15} color="white" />
					</Link>
				</div>

				<div className={style.btn_box}>
					<div className={style.location}>
						<FaMapMarkerAlt color="black" size={20} />
						<p style={{ color: 'black' }}>Bangalore & Dhanbad</p>
					</div>

					<Link to="tel:+919036874408" className={style.text_rows}>
						<p>+91 9036874408</p>
						<FaPhone size={20} />
					</Link>
				</div>
			</div>

			<div className={style.mob_container}>
				<img src={logo} alt="" className={style.logo} />
				<div onClick={() => setShow(!show)}>
					<FaBars size={20} color="white" />
				</div>
			</div>

			{show && (
				<div className={style.mob_div}>
					<div onClick={() => setShow(false)} className={style.btn_close}>
						<FaX size={20} color="black" />
					</div>

					<Link
						className={style.btn_mob}
						to={'https://customer.hometech-repairs.in/'}
					>
						Login <FaUser size={15} color="black" />
					</Link>

					<Link
						className={style.btn_mob}
						onClick={() => setShow(false)}
						to={'/'}
					>
						Home
					</Link>
					<Link
						className={style.btn_mob}
						onClick={() => setShow(false)}
						to={'/service'}
					>
						Services
					</Link>
					<Link
						className={style.btn_mob}
						onClick={() => setShow(false)}
						to={'/about-us'}
					>
						About Us
					</Link>
					<Link
						className={style.btn_mob}
						onClick={() => setShow(false)}
						to={'/contact-us'}
					>
						Contact Us
					</Link>
					<Link
						className={style.btn_mob}
						onClick={() => setShow(false)}
						to={'/privacy-policy'}
					>
						Privacy & Policy
					</Link>
					<Link
						className={style.btn_mob}
						onClick={() => setShow(false)}
						to={'/terms-and-conditions'}
					>
						Terms & Conditions
					</Link>
					<Link
						className={style.btn_mob}
						onClick={() => setShow(false)}
						to={'/feedback'}
					>
						Feed-Back
					</Link>
					<Link to={'tel:+919036874408'} className={style.btn_mob}>
						<p>+91 9036874408</p>
						<FaPhone color="black" size={20} />
					</Link>

					<Link to={'tel:+919036874408'} className={style.btn_mob}>
						<FaMapMarkerAlt color="black" size={20} />
						<p>Bangalore & Dhanbad</p>
					</Link>
				</div>
			)}
		</div>
	);
}

export default Navbar;
